import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/it";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Rome");

const IT_MONTHS = [
  "",
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre",
];

export const dateHelper = {
  toITDate(date) {
    let result = "";
    if (date !== "" && date !== null) {
      result = dayjs(date).format("DD/MM/YYYY");
    }

    return result;
  },

  // Handle date-only values stored as UTC midnight in Italy (22:00Z/23:00Z).
  toITDateFromUtcMidnight(date) {
    let result = "";
    if (date !== "" && date !== null) {
      const match = /^(\d{4}-\d{2}-\d{2})T(22|23):00:00(\.000)?Z$/.exec(date);
      if (match) {
        const hours = match[2] === "22" ? 2 : 1;
        result = dayjs.utc(date).add(hours, "hour").format("DD/MM/YYYY");
      } else {
        result = dayjs(date).format("DD/MM/YYYY");
      }
    }
    return result;
  },

  hourLeft(hour) {
    const toHour = dayjs().format("HH:mm");
    const diff = dayjs(`2000-01-01 ${hour}`).diff(dayjs(`2000-01-01 ${toHour}`), "hours");
    return diff;
  },

  minuteLeft(hour) {
    let diff = 0;
    if (hour) {
      const fromHour = dayjs(`2000-01-01 ${hour}`);

      const toHour = dayjs().format("HH:mm");
      diff = fromHour.diff(dayjs(`2000-01-01 ${toHour}`), "minutes");
    }
    return diff;
  },

  toITDateUTC(date) {
    let result = "";
    if (date !== "" && date !== null) {
      result = dayjs.utc(date).format("DD/MM/YYYY");
    }

    return result;
  },

  toITDayUTC(date) {
    let result = "";
    if (date !== "" && date !== null) {
      result = dayjs.utc(date).locale("it").format("dddd");
    }

    return result;
  },

  toITDay(date) {
    let result = "";
    if (date !== "" && date !== null) {
      result = dayjs(date).locale("it").format("dddd");
    }

    return result;
  },

  toITDateTime(date) {
    return dayjs(date).format("DD/MM/YYYY H:mm");
  },

  toShortTime(date) {
    // remove last 3 characters form the string
    return date.slice(0, -3);
  },

  toITTime(date) {
    return dayjs(date).format("ore H:mm:s");
  },

  toITTimeNoSec(date) {
    return dayjs(date).format("ore H:mm");
  },

  getMonthName(monthNum) {
    const index = parseInt(monthNum);
    return IT_MONTHS[index] || monthNum;
  },

  toUSDate(date) {
    let result = "";
    if (date !== "" && date !== null) {
      result = dayjs(date).format("YYYY-MM-DD");
    }

    return result;
  },

  toUSDateTime(date) {
    return dayjs(date).format("YYYY-MM-DD H:m:s");
  },

  toUSTime(date) {
    return dayjs(date).format("H:m:s");
  },

  secondsToTime(value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    //let seconds = sec - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    //if (seconds < 10) {seconds = "0"+seconds;}

    return `${hours} ore ${minutes} min.`;
  },

  timeInTheFuture(time) {
    let result = false;
    if (time) {
      const fromtime = time;
      const totime = dayjs().format("HH:mm");

      const ft = dayjs(`2000-01-01 ${fromtime}`);
      const tt = dayjs(`2000-01-01 ${totime}`);
      const mins = tt.diff(ft, "minutes", true);
      //console.log(mins);
      result = mins > 0;
    }

    return result;
  },

  noFuture(value) {
    let res = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.test(value);
    if (res && dayjs(value).isAfter(dayjs())) {
      res = false;
    }
    return res;
  },

  dayLeft(value) {
    let res = 0;
    if (value) {
      const toDay = dayjs().format("YYYY-MM-DD");
      const diff = dayjs(value).diff(toDay, "days");
      res = diff;
    }
    return res;
  },

  diff(dateStart, dateEnd) {
    const d1 = dayjs(dateStart);
    const d2 = dayjs(dateEnd);
    return d1.diff(d2);
  },

  diffDays(dateStart, dateEnd) {
    const d1 = dayjs(dateStart);
    const d2 = dayjs(dateEnd);
    return d1.diff(d2, "day");
  },

  addHour(date, hourToAdd) {
    const d = dayjs(date);
    return d.add(hourToAdd, "hour").format("YYYY-MM-DD HH:mm:ss");
  },

  isExpired(date) {
    const d = dayjs(date);
    const now = dayjs();
    const isExpired = now.isAfter(d);

    return isExpired;
  },

  isAfter(date1, date2) {
    const d1 = dayjs(date1);
    const d2 = dayjs(date2);
    return d1.isAfter(d2);
  },
};
